import NumberInput, { type Props as NumberInputProps, type NumericValue } from "components/NumberInput";
import React from "react";

interface Props extends Omit<NumberInputProps, "onChanged" | "onBlur" | "error" | "onEnterPressed" | "onEscPressed"> {
  autoFocus?: boolean
  onChange: (newValue: number) => void
  onEnterPressed: (newValue: number) => void
  onEscPressed?: () => void
}

const OptionalNumberInput = (props: Props) => {
  const { onChange, onEnterPressed, onEscPressed, ...rest } = props;

  const onChanged = async (newValue: NumericValue) => {
    props.onChange(newValue.value);
  };

  return <NumberInput
    {...rest}
    focusOnMount={props.autoFocus}
    onEnterPressed={(v) => onEnterPressed(v.value)}
    onEscPressed={onEscPressed}
    onChanged={onChanged}
  />;
};

export default OptionalNumberInput;